class MyUploadAdapter {
	constructor(loader, editor) {
		// The file loader instance to use during the upload.
		this.loader = loader;
		this.editor = editor;

	}

	// Starts the upload process.
	upload() {
		return this.loader.file
			.then(file => new Promise((resolve, reject) => {
				this.editor.config._config.ngUploader(file, resolve, reject)
			}));
	}
}

// ...

export function MyCustomUploadAdapterPlugin(editor) {
	editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
		// Configure the URL to the upload script in your back-end here!
		return new MyUploadAdapter(loader, editor);
	};
}
